export default __webpack_public_path__ + "static/media/anthem-website-logos_wpengine.6c8ec968.webp";